/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { OccConfig } from '@lm-nx-frontend/lm-inf-core';

export const defaultOccOrganizationUserRegistrationConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        organizationUserRegistration: '/orgUsers',
      },
    },
  },
};
